<!-- Delete Invoice Schedule Modal -->
<div class="modal fade" id="deleteInvoiceScheduleModal" msEscClose
    (escPressed)="onCancel()"
    data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1"
    aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">

            <div class="modal-body text-center">
                <fa-duotone-icon icon="triangle-exclamation" class="confirmation-icon text-warning" />

                <div class="pt-4 px-4" [innerHTML]="BalancesMessagingConstants.PROPERTY_CHARGE_SCHEDULE_DELETE_CONFIRMATION()">                    
                </div>

                <form [formGroup]="deleteForm" (keydown.enter)="$event.preventDefault()" class="px-4 py-0 text-start">

                    <!-- Void Open and Late invoices -->
                    <div class="form-check mt-4">
                        <input
                            type="checkbox"
                            id="deleteScheduleVoidInvoices"
                            formControlName="voidOpenAndLateInvoices"
                            class="form-check-input" />
                        <label
                            class="form-check-label"
                            for="deleteScheduleVoidInvoices"
                            [innerHTML]="BalancesMessagingConstants.PROPERTY_CHARGE_SCHEDULE_DELETE_VOID_INVOICES_LABEL()">
                        </label>
                    </div>

                    <!-- Send email notifications (nested, disabled unless void is checked) -->
                    <div class="form-check ms-4 mt-2">
                        <input
                            type="checkbox"
                            id="deleteScheduleSendNotifications"
                            formControlName="sendEmailNotifications"
                            class="form-check-input" />
                        <label class="form-check-label" for="deleteScheduleSendNotifications"
                            [class.text-muted]="!deleteForm.get('voidOpenAndLateInvoices')?.value">
                            {{ BalancesMessagingConstants.PROPERTY_CHARGE_SCHEDULE_DELETE_SEND_NOTIFICATIONS_LABEL() }}
                        </label>
                    </div>

                    <!-- Notes (optional) -->
                    <ms-input-label [labelText]="'Notes'" class="mt-3" />
                    <textarea
                        id="deleteScheduleNote"
                        formControlName="note"
                        maxlength="255"
                        rows="3"
                        class="form-control"
                        [class.is-invalid]="deleteForm.get('note')?.invalid && deleteForm.get('note')?.touched"
                        [class.is-valid]="deleteForm.get('note')?.valid && deleteForm.get('note')?.touched && deleteForm.get('note')?.value !== ''">
                    </textarea>
                    @if (deleteForm.get('note')?.errors?.['maxlength'] && deleteForm.get('note')?.touched) {
                        <div class="error-messages">
                            <p class="text-danger text-start pt-1 mb-0">{{ FormValidatorMessages.NoteMaxLength }}</p>
                        </div>
                    }
                </form>
            </div>

            <div class="modal-footer border-0 d-flex justify-content-center pb-4">
                <button type="button" class="btn btn-ms-secondary" (click)="onCancel()" [disabled]="isSubmitting">
                    No
                </button>
                <button type="button" class="btn btn-primary" (click)="onSubmit()" [disabled]="isSubmitting">
                    @if (isSubmitting) {
                        <div class="spinner-border text-light spinner-border-sm" role="status">
                            <span class="visually-hidden">Loading...</span>
                        </div>
                    } @else {
                        Yes
                    }
                </button>
            </div>

        </div>
    </div>
</div>

<!-- Info Modal -->
<ms-info-modal #deleteInvoiceScheduleInfoRef modalId="deleteInvoiceScheduleInfoModal"
    (onConfirm)="infoModalConfirmed()" />

<!-- Esc Confirmation Modal -->
<ms-confirmation-modal
    #deleteInvoiceScheduleEscConfirmationRef
    modalId="deleteInvoiceScheduleEscConfirmationModal"
    confirmButtonText="Leave"
    cancelButtonText="Stay"
    (confirmed)="onEscConfirmed()"
    (cancelled)="onEscCancelled()"
/>
